export class PhoneNumberDTO {
  public format: string;
  public number: string;
}